export const TRANSLATIONS = {
  PANEL_TITLE: 'custom_menu_delete_menu_popup_header', // accepts `menu_name_to_delete` as an argument
  DESCRIPTION_1: 'custom_menu_delete_menu_popup_text_1', // accepts `menu_name_to_delete` and `menu_name_to_substitute` as arguments
  DESCRIPTION_2: 'custom_menu_delete_menu_popup_text_2',
  CONFIRM_LABEL: 'custom_menu_delete_menu_popup_primary_CTA',
  CANCEL_LABEL: 'custom_menu_delete_menu_popup_secondary_CTA',
};
